import React from 'react';
import {angles} from './list';
import AnglesList from './AnglesList';

export default function AllAngles(props) {
  return <div className="all-angles">
    <AnglesList list={angles} />
  </div>;
};
